import { IPage } from '../../types/shared';

const getInternalLink = (
  page: IPage | string,
  link?: string,
  baseUrl?: string
): string => {
  if (!page || (typeof page !== 'string' && page?.slug === '' && !link)) {
    return '404/';
  }

  if (typeof page === 'string' && page !== '') {
    return page;
  }

  let newLink = link || '';

  if (typeof page !== 'string' && page.slug) {
    if (page.slug === '#') {
      // if homepage return empty string
      if (!baseUrl && !newLink) {
        return '';
      }

      return baseUrl ? `${baseUrl}/${newLink}/` : `${newLink}/`;
    }

    newLink = link ? `${page.slug}/${link}` : page.slug;
  }

  if (typeof page !== 'string' && page.parentPage) {
    return getInternalLink(page.parentPage, newLink, baseUrl);
  }

  return baseUrl ? `${baseUrl}/${newLink}/` : `${newLink}/`;
};

export { getInternalLink };
